// @ts-nocheck

import * as Yup from 'yup';

export function settingsSchema() {
  const phoneRegEx = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)$/;

  return Yup.object().shape({
    billingAddress: Yup.string().required('Billing Address is Required.'),
    accountName: Yup.string().required('Account Name is Required.'),
    primaryAcctPhoneNumber: Yup.string()
      .trim()
      .matches(phoneRegEx, 'Invalid phone number.')
      .test(
        'required if primary account phone number toggle is on',
        'Primary account phone number required based on Ride Preferences.',
        function fn(primaryAcctPhoneNumber) {
          if (this.parent.contactPrimaryAcctPhoneNumber === 'Yes') {
            return primaryAcctPhoneNumber && primaryAcctPhoneNumber.length > 0;
          }

          return true;
        }
      ),
    ecName: Yup.string()
      .nullable()
      .test('blank name', 'Emergency contact name is required.', function fn(ecName) {
        if (
          (this.parent.ecEmail && this.parent.ecEmail.length > 0) ||
          (this.parent.ecPhoneNumber && this.parent.ecPhoneNumber.length > 0)
        ) {
          return ecName && ecName.length > 0;
        }

        return true;
      }),
    ecEmail: Yup.string()
      .trim()
      .nullable()
      .email('Invalid email.')
      .test('blank email', 'Emergency contact email is required.', function fn(ecEmail) {
        if (
          (this.parent.ecName && this.parent.ecName.length > 0) ||
          (this.parent.ecPhoneNumber && this.parent.ecPhoneNumber.length > 0)
        ) {
          return ecEmail && ecEmail.length > 0;
        }

        return true;
      }),
    ecPhoneNumber: Yup.string()
      .trim()
      .nullable()
      .when({
        is: (val) => val && val.length > 0,
        then: Yup.string().matches(phoneRegEx, 'Invalid phone number.'),
      }),
    dailyReportEmailList: Yup.string().test(
      'empty list',
      'Please specify at least one valid email.',
      function fn(dailyReportEmailList) {
        const emails = dailyReportEmailList ? dailyReportEmailList.replace(/\s+/g, '').split(',') : [];

        return this.parent.sendEmailDailyReport === 'Yes'
          ? emails.length > 0 && emails[0] !== ''
          : this.parent.sendEmailDailyReport === 'No';
      }
    ),
  });
}
